export default __webpack_public_path__ + "static/media/plug.07303580.svg";